module.exports = __webpack_public_path__ + "assets-cabinet/img/qr.66cd5c55.svg";